import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appUppercase]'
})
export class UppercaseDirective {

  constructor(private el: ElementRef) {
  }

  @HostListener('change') onChange() {
    console.log(this.el.nativeElement);
  }
}



// WEBPACK FOOTER //
// ./src/app/uppercase.directive.ts